import { DocumentScannerScreen } from '@/modules/onboarding/identity/document-scanner';
import React from 'react';

export default function DocumentScanner() {
    return <DocumentScannerScreen />;
}